import { render, staticRenderFns } from "./DadosFornecedor.vue?vue&type=template&id=faca821c&"
import script from "./DadosFornecedor.vue?vue&type=script&lang=js&"
export * from "./DadosFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports